import { AUTO_REGISTRATION_INFO } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(AUTO_REGISTRATION_INFO)
